import { create } from 'zustand';

const INITIAL_STATE = {

    motive: 0

};

export const useDeleteTripModalStore = create((set, get) => ({

    ...INITIAL_STATE,

    setMotive: (motive) => {

        set(state => {

            if (state.motive === motive) {
                return state;
            }

            return { motive };

        });

    },

    clear: () => {

        set(state => {

            if (
                state.motive === INITIAL_STATE.motive
            ) {
                return state;
            }

            return {
                ...INITIAL_STATE
            };

        });

    },

    exportState: () => {

        const {
            motive
        } = get();

        return {
            motive
        };

    },

    importState: (state) => {

        if (!state) {
            return;
        }

        set({
            ...state
        });

    },

}));